

const ROOM_WALL_NORTH     = "north";
const ROOM_WALL_SOUTH     = "south";
const ROOM_WALL_EAST      = "east";
const ROOM_WALL_WEST      = "west";

const    ROOM_TYPE_NESW    = "1111";
const    ROOM_TYPE_NEW     = "1101";
const    ROOM_TYPE_NSW     = "1011";
const    ROOM_TYPE_ESW     = "0111";
const    ROOM_TYPE_NES     = "1110";
const    ROOM_TYPE_EW      = "0101";
const    ROOM_TYPE_NS      = "1010";
const    ROOM_TYPE_SW      = "0011";
const    ROOM_TYPE_ES      = "0110";
const    ROOM_TYPE_NW      = "1001";
const    ROOM_TYPE_NE      = "1100";
const    ROOM_TYPE_N       = "1000";
const    ROOM_TYPE_E       = "0100";
const    ROOM_TYPE_S       = "0010";
const    ROOM_TYPE_W       = "0001";
const    ROOM_TYPE_EMPTY   = "0000";


export default class Room
{
  constructor({roomID=-1})
  {
    this.m_roomID = roomID;

    this.m_visited = false;       //by default, this room has not yet been visited 

    //by default room is init with all the walls in place
    this.m_wall_north = 1;
    this.m_wall_south = 1;
    this.m_wall_east = 1;
    this.m_wall_west = 1;

  }


  setRoomID(roomID)
  {
    this.m_roomID = roomID;
  }


  getRoomID()
  {
    return this.m_roomID;
  }



  tearDownWall(direction)
  {
    switch (direction)
    {
      case ROOM_WALL_NORTH:
      {
        this.m_wall_north = 0;
        break;
      }
      case ROOM_WALL_EAST:
      {
        this.m_wall_east = 0;
        break;
      }
      case ROOM_WALL_SOUTH:
      {
        this.m_wall_south = 0;
        break;
      }
      case ROOM_WALL_WEST:
      {
        this.m_wall_west = 0;
        break;
      }
      default:
      {
        return 0;     //to indicate an invalid wall choice
      }
    };

    return 1;
  }


  getRoomType()
  {
    // let roomNum = this.m_wall_north * 1000 + this.m_wall_east * 100 + this.m_wall_south * 10 + this.m_wall_west;
    // return roomNum.toString();

    let roomNum = this.m_wall_north.toString() + this.m_wall_east.toString() + this.m_wall_south.toString() + this.m_wall_west.toString();
    return roomNum;

  }


  isVisited()
  {
    return this.m_visited;
  }


  //mark this room as visited 
  visitRoom()
  {
    this.m_visited = true;
  }

};
